import type { IPropertyApiResponseModel } from '@/shared/models/property.api.response.model';
import type { IVideoMakerFormValues } from '../videoMaker.models';

export const createVideoPayload = (values: IVideoMakerFormValues, propertyData: IPropertyApiResponseModel) => {
  return {
    templateId: values.selectedTemplateId,
    modifications: {
      'property_image_1.source': values.selectedImages[0]?.preSignedUrl || '',
      'property_image_2.source': values.selectedImages[1]?.preSignedUrl || '',
      'property_image_3.source': values.selectedImages[2]?.preSignedUrl || '',
      'property_image_4.source': values.selectedImages[3]?.preSignedUrl || '',
      'property_address.text': values.caption || '',
      'property_desc.text': values.propertyDescription2 || '',
      'property_desc-T6Q.text': values.propertyDescription2 || '',
      'property_kvm.text': values.areaInUsage || '',
      'property_soverom.text': values.bedroom || '',
      'property_standard.text': values.propertyStandard || '',
      'broker_image.source': values.employeeAvatar || '',
      'office.text': values.officeName || '',
      'email.text': values.employeeEmail || '',
      'phone.text': values.employeePhone || '',
      'broker_name.text': values.employeeName || '',
    },
  };
};
